import {
  Text,
  Flex,
  TooltipText,
  useTooltip,
  Skeleton,
  Heading,
  Box,
  Button,
} from "@pancakeswap/uikit";
import React, { useEffect, useState } from "react";
// import Balance from 'components/Balance'
import styled, { keyframes, css } from "styled-components";
import Balance from "../../../../../components/Balance";
import { getContract } from "utils/contractHelpers";
import DrivenStakingABI from "ABI/DrivenStakingABI.json";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import { getLockUpAddress } from "utils/addressHelpers";
import { useWeb3React } from "@web3-react/core";
import { useLocation } from "react-router-dom";
import WithdrawModal from "../../Modal/WithdrawModal";
import { setPidx } from "store/IndexSlice";
import { useDispatch, useSelector } from "react-redux";
import LoopIcon from "@mui/icons-material/Loop";
import { ethers } from "ethers";

interface AutoHarvestActionProps {
  pool: any;
}

export const ActionContainer = styled.div<{ isAutoVault?: boolean }>`
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.colors.input};
  border-radius: 16px;
  flex-grow: 1;
  flex-basis: 0;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 0;
    height: auto;
  }
`;

export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 12px;
`;

export const ActionContent = styled.div`
  /* padding: 16px; */
  -webkit-box-flex: 1;
  flex-grow: 1;
  flex-basis: 0px;
  margin-bottom: 16px;
`;

const Earned = styled.div`
  font-weight: 600;
  font-size: 12px;
  padding-top: 10px;
  display: flex;
  /* justify-content: space-around; */
  text-transform: uppercase;
`;

const Compound = styled.div`
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
`;

const CompoundButtoon = styled(Button)`
  background-color: #00fed9;
  color: #000000;
  border-color: rgb(233, 234, 235);
  box-shadow: none;
  // cursor: not-allowed;
  align-items: center;
  justify-content: space-between;
  border: 0px;
  border-radius: 16px;
  display: inline-flex;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  margin-bottom: 4px;
  height: auto;
  width: 92px;
  padding: 5px 10px;
  font-size: 12px;
`;

const Buttons = styled(Box)`
  display: flex;
  flex-direction: column;
`;
const AutoHarvestAction: React.FunctionComponent<AutoHarvestActionProps> = ({
  pool,
}) => {
  // console.log("harvest", pool)
  const { error, connector, activate, deactivate, library, active, account } =
    useWeb3React();
  const [compoundloading, setCompoundLoading] = useState(false);
  // const [withdrawloading, setWithdrawLoading] = useState(false);
  const [harvestloading, setHarvestLoading] = useState(false);
  const [harvestdisable, setHarvestDisable] = useState(true);

  const dispatch = useDispatch();
  const pidx = useSelector((state: any) => state.Index.processidx);
  const compoundReward = async (pooltype, calltype) => {
    if (account) {
      // setLoading(true);
      try {
        let tx;
        if (pool.contractType === "lockup") {
          const lockUpAddress = getLockUpAddress();
          const lockUpContract = getContract(
            DrivenLockupABI,
            lockUpAddress,
            library.getSigner()
          );
          switch (calltype) {
            case "compound":
              setCompoundLoading(true);
              tx = await lockUpContract.compoundReward(pooltype);
              break;
            case "harvest":
              setHarvestLoading(true);
              tx = await lockUpContract.claimReward(pooltype); //only owner contract deployer
              break;
          }
        }
        await tx.wait();
        // dispatch(setPidx(pidx + 1));
      } catch (err) {
        console.log(err);
      }
      // setLoading(false);
      setCompoundLoading(false);
      setHarvestLoading(false);
    }
  };

  useEffect(() => {
    async function checkLockup() {
      if (account) {
        const lockUpContract = getContract(DrivenLockupABI, getLockUpAddress());
        let time = await lockUpContract.getLatestLockEndTime(
          account,
          pool.stackType
        );
        if (parseFloat(ethers.utils.formatEther(pool.user.userstack)) > 0) {
          if (pool.user.stakeendin == '0') {
            setHarvestDisable(false);
            console.log(parseFloat(ethers.utils.formatEther(pool.user.userstack)))
            return;
          }
          if (time.lte(0) || pool.stackType == 2 || pool.stackType == 3) {
            setHarvestDisable(false);
          }
          else if (pool.user.stakeendinEpoch > Math.ceil((new Date()).getTime() / 1000))
            setHarvestDisable(true);
          else
            setHarvestDisable(false);

        } else {
          setHarvestDisable(true);
        }
      }
    }
    checkLockup();
  }, [account, pidx, pool]);

  const [withdrawopen, setwithdrawOpen] = React.useState(false);

  const emergencyWithdraw = () => setwithdrawOpen(true);
  const withdrawClose = () => setwithdrawOpen(false);

  // const earningTokenBalance = autoCakeToDisplay
  // const earningTokenDollarBalance = autoUsdToDisplay
  // const hasEarnings = hasAutoEarnings

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    "Subtracted automatically from each yield harvest and burned.",
    { placement: "bottom-start" }
  );

  return (
    // <ActionContainer isAutoVault>
    <>
      <Box>
        <ActionContent>
          <Earned>
            <ActionTitles>
              <Text
                fontSize="14px"
                bold
                color="#00FED9"
                as="span"
                textTransform="uppercase"
              >
                {"DVX"}{" "}
              </Text>
              <Text
                fontSize="14px"
                bold
                color="#00FED9"
                as="span"
                textTransform="uppercase"
              >
                {"Earned"}{" "}
              </Text>
            </ActionTitles>
          </Earned>
          <Compound>
            {active ?
              <Box mr="8px" height="32px">
                <Balance
                  // display="inline"
                  fontSize="16px"
                  decimals={2}
                  prefix=""
                  color="white"
                  value={pool.user.pendingreward}
                  unit=""
                />
              </Box>
              :

              <Box mr="8px" height="32px">
                <Balance
                  // display="inline"
                  fontSize="16px"
                  decimals={2}
                  prefix=""
                  color="white"
                  value={0}
                  unit=""
                />
              </Box>


            }

            <Buttons>
              {pool.enableCompound === "true" && (
                <>
                  <CompoundButtoon
                    onClick={() => compoundReward(pool.stackType, "compound")}
                    disabled={
                      active && parseFloat(pool.user.pendingreward) > 0.0
                        ? compoundloading
                        : true
                    }
                  >
                    Compound{" "}
                    {compoundloading && (
                      <Box>
                        <LoopIcon
                          className="animation-spin"
                          sx={{ width: "12px", height: "12px" }}
                        />
                      </Box>
                    )}
                  </CompoundButtoon>
                </>
              )}
              {/* <CompoundButtoon onClick={() => emergencyWithdraw()} disabled={active && parseFloat(pool.user.pendingreward) > 0.0 ? withdrawloading : true}>
                                Withdraw
                            </CompoundButtoon> */}
              <CompoundButtoon
                onClick={() => compoundReward(pool.stackType, "harvest")}
                disabled={!active || harvestdisable || harvestloading}
              >
                Harvest{" "}
                {harvestloading && (
                  <Box>
                    <LoopIcon
                      className="animation-spin"
                      sx={{ width: "12px", height: "12px" }}
                    />
                  </Box>
                )}
              </CompoundButtoon>
            </Buttons>
          </Compound>
        </ActionContent>
      </Box>

      <WithdrawModal
        open={withdrawopen}
        onClose={withdrawClose}
        pool={pool}
      ></WithdrawModal>
    </>
    // </ActionContainer>
  );
};

export default AutoHarvestAction;
